import { Link } from "@inertiajs/react"
import { Users2 } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { candidatesPath } from "@/routes"

/**
 * OKS-65 — Full-page cold-start empty card for `/brand/analytics/crew`.
 *
 * Rendered when the service returns `state: :cold_start` (zero active
 * CrewMembership rows for the brand). The CTA points at the
 * `candidatesPath()` canonical brand-side "find / invite creators"
 * surface (UX Spec §1 mentions `newCrewInvitePath`, but the live
 * route is `candidatesPath` per `BrandSidebar`'s entry).
 */
export function CrewAnalyticsEmpty() {
  const { t } = useTranslation()

  return (
    <Card
      data-testid="crew-analytics-empty"
      className="mx-auto flex max-w-md flex-col items-center gap-3 p-6 text-center"
    >
      <CardContent className="flex flex-col items-center gap-3 p-0">
        <Users2
          className="text-muted-foreground h-10 w-10"
          aria-hidden="true"
        />
        <h2 className="text-foreground text-base font-semibold">
          {t("analytics.crew.cold_start.heading")}
        </h2>
        <p className="text-muted-foreground text-sm">
          {t("analytics.crew.cold_start.body")}
        </p>
        <Button asChild>
          <Link href={candidatesPath()} data-testid="crew-analytics-empty-cta">
            {t("analytics.crew.cold_start.cta")}
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}
